import {Type} from '@github-ui/react-query-persister/typebox'

export const ViewMode = {
  ThreadPreviews: 'thread-previews',
  IssueComments: 'issue-comments',
  Mine: 'mine',
} as const

export const ViewModeSchema = Type.Enum(Object.values(ViewMode))

export type ViewMode = Type.Static<typeof ViewModeSchema>

export const supportsCodeOrderSort = (viewMode: ViewMode) => viewMode !== ViewMode.IssueComments
